import { render } from "./TopProducts.vue?vue&type=template&id=5d228dc3&scoped=true"
import script from "./TopProducts.vue?vue&type=script&lang=js"
export * from "./TopProducts.vue?vue&type=script&lang=js"

import "./TopProducts.vue?vue&type=style&index=0&id=5d228dc3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d228dc3"]])

export default __exports__